const LAKH_CRORE_LOCALE = 'en-IN';

const numberFormatter = new Intl.NumberFormat(LAKH_CRORE_LOCALE);
const wholeNumberFormatter = new Intl.NumberFormat(LAKH_CRORE_LOCALE, { maximumFractionDigits: 0 });
const TWO_DECIMALS = 2;
const twoDecimalFormatter = new Intl.NumberFormat(LAKH_CRORE_LOCALE, {
  minimumFractionDigits: TWO_DECIMALS,
  maximumFractionDigits: TWO_DECIMALS,
});
const HUNDREDTHS = 100;
const PERCENT = 100;
const compactNumberFormatter = new Intl.NumberFormat(LAKH_CRORE_LOCALE, {
  notation: 'compact',
  maximumFractionDigits: 0,
});
const pluralRules = new Intl.PluralRules('en-US');
const moneyFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });
const WHOLE_NUMBER_TEXT_PATTERN = /^\d*$/;
const LEADING_ZEROS_PATTERN = /^0+(?=\d)/;

export function formatNumber(value: number | null | undefined): string {
  return numberFormatter.format(value ?? 0);
}

export function formatWholeNumber(value: number | null | undefined): string {
  return wholeNumberFormatter.format(value ?? 0);
}

export function formatWithoutPaisa(value: number | null | undefined): string {
  return wholeNumberFormatter.format(Math.trunc(value ?? 0));
}

export function divideToHundredths(numerator: number, denominator: number): number {
  if (denominator === 0) return 0;
  return Math.floor((2 * numerator * HUNDREDTHS + denominator) / (2 * denominator)) / HUNDREDTHS;
}

export function formatTwoDecimals(value: number): string {
  return twoDecimalFormatter.format(value);
}

export function formatPercentOf(part: number, whole: number): string {
  return `${formatTwoDecimals(divideToHundredths(part * PERCENT, whole))}%`;
}

export function formatCompactNumber(value: number): string {
  return compactNumberFormatter.format(value);
}

export function formatTaka(value: number | null | undefined): string {
  return `৳${moneyFormatter.format(value ?? 0)}`;
}

export function parseNumberText(text: string): number | undefined {
  if (text.trim() === '') return undefined;
  const parsed = Number(text);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function normalizeWholeNumberText(text: string): string | undefined {
  if (!WHOLE_NUMBER_TEXT_PATTERN.test(text)) return undefined;
  return text.replace(LEADING_ZEROS_PATTERN, '');
}

export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return pluralRules.select(count) === 'one' ? singular : plural;
}

export function formatCount(count: number, singular: string): string {
  return `${count} ${pluralize(count, singular)}`;
}

const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB'] as const;

/** 1 KB = 1024 bytes, as the upload limits count them. */
export function formatFileSize(bytes: number): string {
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < FILE_SIZE_UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${unit === 0 ? value : value.toFixed(1)} ${FILE_SIZE_UNITS[unit]}`;
}
